import { TSADocPacketGet, TSADocPacketGetUI } from './AnimalTraining.types';
import {
  EGender,
  EValueEditingStates,
  TFail,
  TFailUI,
} from './GeneralTypes';
import { TDocPacketGet, TDocPacketGetUI } from './DocPacket.types';

export enum EApplicationStepName {
  'Property management' = 'Property management',
  SA = 'SA',
  ESA = 'ESA',
  PET = 'PET',
  'Tenant Profile' = 'Tenant Profile',
  Training = 'Training',
  Payment = 'Payment',
}

export enum EApplicationStepNameUi {
  'Property management' = 'Property management',
  SA = 'SA',
  ESA = 'ESA',
  PET = 'PET',
  'Tenant Profile' = 'Tenant Profile',
  Training = 'Training',
  Payment = 'Payment',
}

export enum EApplicationTypeDB {
  ESA = 'ESA',
  SA = 'SA',
  PET = 'PET',
}

export enum EApplicationTypeUI {
  ESA = 'ESA',
  SA = 'SA',
  PET = 'PET',
}

export enum EStatusChangerRoleDB {
  PROPERTY_MANAGER = 'PROPERTY_MANAGER',
  ADMIN = 'ADMIN',
}

export enum EStatusChangerRoleUI {
  PROPERTY_MANAGER = 'property manager',
  ADMIN = 'OPP team',
}

export enum EApplicationStepTypeUi {
  PROPERTY_MANAGEMENT = 'PROPERTY_MANAGEMENT',
  TENANT_PROFILE = 'TENANT_PROFILE',
  ANIMAL = 'ANIMAL',
  TRAINING = 'TRAINING',
  BILLING = 'BILLING',
}

export enum EApplicationStepType {
  PROPERTY_MANAGEMENT = 'PROPERTY_MANAGEMENT',
  TENANT_PROFILE = 'TENANT_PROFILE',
  ANIMAL = 'ANIMAL',
  TRAINING = 'TRAINING',
  BILLING = 'BILLING',
}

export enum EApplicationAnimalStatus {
  NONE = 'NONE',
  VERIFIED = 'VERIFIED',
}
export enum EApplicationAnimalStatusUi {
  NOT_VERIFIED = 'Not verified',
  VERIFIED = 'Verified',
}

export type TEditingWeightFieldUi = {
  value: string | null;
  unit: string | null;
  canEdit: boolean;
  canRemove: boolean;
};

export type TEditingWeightField = {
  value?: number | null;
  unit?: string | null;
  allowedOperations: EValueEditingStates[];
};

export type TAnimalDetailsGenderField = {
  value: EGender;
  allowedOperations: EValueEditingStates[];
};

export type TApplicationSADocPacketGetUI = TSADocPacketGetUI & {
  fails?: TFailUI[];
};
export type TApplicationSADocPacketGet = TSADocPacketGet & { fails?: TFail };

export type TApplicationHPPacketUI = TDocPacketGetUI & {
  fails?: TFailUI[];
};
export type TApplicationHPPacket = TDocPacketGet & {
  fails?: TFail;
};

export enum EMethodDB {
  SIMPLE = 'SIMPLE',
  APPROVE_WITH_APPLICANT_TENANT_RESIDENCY = 'APPROVE_WITH_APPLICANT_TENANT_RESIDENCY',
  APPROVE_WITH_MOVED_IN_TENANT_RESIDENCY = 'APPROVE_WITH_MOVED_IN_TENANT_RESIDENCY',
}

export enum EMethodUI {
  SIMPLE = 'SIMPLE',
  APPROVE_WITH_APPLICANT_TENANT_RESIDENCY = 'APPROVE_WITHOUT_TENANT_RESIDENCY',
  APPROVE_WITH_MOVED_IN_TENANT_RESIDENCY = 'APPROVE_WITH_MOVED_IN_TENANT_RESIDENCY',
}
